var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"title":"Delete","href":"javascript:void(0)"},on:{"click":_vm.openModal}},[_c('i',{staticClass:"text-danger fa fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }